import { Dictionary } from './core/dictionary_T';
import { FilterCriteria } from './filter-criteria';

/**
 * Représente les filtres saisies par l'utilisateur pour la liste des dossiers.
 */
export class AttributeFilters extends Dictionary<FilterCriteria> {
    /**
     * Instancie une instance de AttributeFilters
     * @param other : Representation JSON du AttributeFilters
     * @returns une instance de AttributeFilters
     */
    public static from(other) {
        if (!!other) {
            const instance = new AttributeFilters();

            Object.keys(other.items).forEach((key) => {
                const filterCriteria = FilterCriteria.from(other.items[key]);
                instance.set(key, filterCriteria);
            });

            return instance;
        } else {
            return null;
        }
    }

    public copyFrom(other: any) {
        if (!!other) {
            Object.keys(other).forEach((key) => {
                this.set(key, FilterCriteria.from(other[key]));
            });
        }
    }
}
